"use client";

import { memo } from "react";
import { Box, Heading } from "@chakra-ui/react";

export interface SectionTitleProps {
  title: string;
}

export const SectionTitle = memo<SectionTitleProps>(({ title }) => (
  <Box mb={3}>
    <Heading
      as="h2"
      textStyle="xl"
      fontWeight="bold"
      color="neutral.900"
      textTransform="uppercase"
      letterSpacing="0.5px"
      mb={2}
    >
      {title}
    </Heading>
    <Box
      height="1px"
      borderTop="1px dotted"
      borderColor="neutral.200"
      width="100%"
    />
  </Box>
));
SectionTitle.displayName = "SectionTitle";
